import {
  ExchangeState,
  CouponState,
  TransState,
  ExpireState,
  ICouponBatchInfo,
  ICashCouponUI,
  ICashCouponInfo,
} from '@tencent/wphk-act-base-types';

export {
  /** 券状态 */
  CouponState,
  /** 券兑换状态 */
  ExchangeState,
  /** 券使用状态 */
  TransState,
  /** 券过期状态 */
  ExpireState,
  /** 券批次信息 */
  ICouponBatchInfo,
  /** 金额券基本UI */
  ICashCouponUI,
  /** 现金优惠券用户信息 */
  ICashCouponInfo,
};

export enum CouponVersion {
  'old' = 1,
  'new'
};
